import { Map, fromJS } from 'immutable';

export function request(state, { id }) {
    let items = state.get('items') || Map();

    items = items.set(
        id,
        items.get(id).set('_state', 'IN_PROGRESS')
    );

    return state.set('items', items);
}

export function error(state, { id, errors }) {
    let items = state.get('items') || Map();

    items = items.set(
        id,
        items.get(id)
            .set('_state', 'ERROR')
            .set('errors', fromJS(errors))
    );

    return state.set('items', items);
}

export function finish(state, { id, data }) {
    let items = state.get('items') || Map();

    data._state = 'FINISHED';

    return state.setIn([ 'items', id ], fromJS(data));
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach(grade => {
        let item = items.get(grade.id) || Map();

        items = items.set(grade.id, item.merge(grade));
    });

    return state.set('items', items);
}
